export const HEADLINES = [
  "Connecting Goa to Global Business Opportunities",
  "Where Goa Meets the Global Business World",
  "Goa's Gateway to Trade, Tourism & Global Expansion",
  "Connecting Global Investors to Goa's Rising Opportunities",
];

export const OPPORTUNITY_CATEGORIES = [
  { key: "tourism", title: "Tourism & Hospitality", number: "01", icon: "Anchor" },
  { key: "trade", title: "International Trade & Exports", number: "02", icon: "Globe" },
  { key: "realestate", title: "Luxury Real Estate", number: "03", icon: "Buildings" },
  { key: "partnerships", title: "Strategic Partnerships", number: "04", icon: "Handshake" },
  { key: "startup", title: "Startup & Investment", number: "05", icon: "Rocket" },
  { key: "sustainability", title: "Sustainability & Green", number: "06", icon: "Leaf" },
  { key: "lifestyle", title: "Restaurants & Lifestyle", number: "07", icon: "ForkKnife" },
  { key: "wellness", title: "Wellness & Retreats", number: "08", icon: "Flower" },
  { key: "tech", title: "Technology & Innovation", number: "09", icon: "CircuitryFill" },
  { key: "media", title: "Events, Entertainment & Media", number: "10", icon: "FilmReel" },
  { key: "manufacturing", title: "Manufacturing & MSME", number: "11", icon: "Factory" },
  { key: "maritime", title: "Coastal & Maritime", number: "12", icon: "Boat" },
];

export const USER_PATHS = [
  { key: "invest", label: "Invest" },
  { key: "partner", label: "Partner" },
  { key: "trade", label: "Trade" },
  { key: "expand", label: "Expand" },
  { key: "collaborate", label: "Collaborate" },
  { key: "discover", label: "Discover Opportunities" },
];

export const SECTORS = OPPORTUNITY_CATEGORIES.map((c) => c.title);

export const TICKET_SIZES = [
  "Under $100K",
  "$100K – $500K",
  "$500K – $2M",
  "$2M – $10M",
  "$10M – $50M",
  "$50M+",
];

export const TRUST_METRICS = [
  { value: "12+", label: "Premium Sectors" },
  { value: "100%", label: "Verified Listings" },
  { value: "0₹", label: "Goa Business Registration" },
  { value: "Global", label: "Investor Reach" },
];
